import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, DialogActions } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

const StatusPopup = ({
  wrapperCallback,
  title,
  decription,
  icon,
  onClose,
  open,
  fullWidth,
  maxWidth,
  showCloseButton = true,
  disableClose = false,
  aditionalInfoDialog,
}) => {
  const handleDialogClose = (_event, reason) => {
    if (disableClose && (reason === 'backdropClick' || reason === 'escapeKeyDown')) {
      return;
    }

    onClose();
  };

  const dialogElement = (
    <Dialog
      onClose={handleDialogClose}
      open={open}
      fullWidth={fullWidth}
      maxWidth={maxWidth || 'xs'}
      disableEscapeKeyDown={disableClose}
    >
      <DialogTitle
        sx={{
          textAlign: 'right',
          pb: 0,
        }}
      >
        {showCloseButton && (
          <CloseIcon onClick={onClose} sx={{ cursor: 'pointer', color: '#B7B6BE', fontSize: 22 }} />
        )}
      </DialogTitle>

      <DialogContent
        sx={{
          pt: 1,
          pb: 4,
          px: { xs: 2.5, sm: 4 },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: 1.5,
          }}
        >
          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {icon}
          </Box>
        </Box>

        <Typography
          variant='h5'
          sx={{
            textAlign: 'center',
            fontWeight: 700,
            color: '#2F2D3A',
            mb: 3,
            fontSize: { xs: '0.8rem', sm: '1.25rem' },
          }}
        >
          {title}
        </Typography>

        <Typography
          sx={{
            textAlign: 'center',
            color: '#2F2D3A',
            fontSize: { xs: '0.8rem', sm: '0.9rem' },
          }}
        >
          {decription}
        </Typography>

        {aditionalInfoDialog && <Box mt={3}>{aditionalInfoDialog}</Box>}
      </DialogContent>
      {!aditionalInfoDialog && (
        <DialogActions sx={{ justifyContent: 'center', pb: 4 }}>
          <Button
            onClick={onClose}
            variant='text'
            sx={{
              '&:hover': {
                backgroundColor: 'transparent',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.12)',
              },
            }}
          >
            Aceptar
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );

  return wrapperCallback ? wrapperCallback(dialogElement) : dialogElement;
};

export default StatusPopup;
